import React from "react";
import { Container } from "reactstrap";
import EcoProButton from "../../shared/button/button";
import BrotherConnectModal from "../../../assets/images/BrotherPlus/brother-connect-modal.png"
import { Trans, useTranslation } from "react-i18next";
import { addUserActivityLogRequest } from "../../../store/brotherPlus/AddUserActivityLogService/addUserActivityLogServiceSlice";
import './DashboardPopup.css';
import EasyPayPlanSkipNow from "../../Web/Customer/BrotherPlus/EasyPayPlan/SkipNow/SkipNow";
import { EnrollmentRegisterServiceInit } from "../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import BPlusBenefitPoints from "../../Web/Customer/BrotherPlus/BPlusBenefitPoints/BPlusBenefitPoints";
import { ENVSettings } from "../../../constants/ENVSettings";
import { useDispatch } from "react-redux";

const DashboardPopup = (props) => {
    const { handleModalContinue, onSkipService, showSkip, onClose, showGetStartedBtn } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation(["translation"]);
    const signup_privacyPolicy = `https://store.brother.co.uk/legals/privacy-policy`;
    const termsAndConditionLink = ENVSettings.BROTHER_CONNECT_TERMS_AND_CONDITIONS;


     const handleSkipNow = () => {
        onSkipService(true);
        onClose();
    }

    const onPopUpSubmit = () => {
        dispatch(addUserActivityLogRequest());
        if (showGetStartedBtn) {
            dispatch(EnrollmentRegisterServiceInit({ enrollmentFor: 'ECOPRO_USER' }));
        }
        else {
            handleModalContinue();
        }
    }

    return (
        <Container className="brother-plus-dashboard-popup">
            <img src={BrotherConnectModal} className="bronter-connect-modal-background-img" alt="party-horn" title="party-horn" />
            <div className="brother-connect-content-wrapper">
                <h1>{t("BROTHER_PLUS.BROTHER_CONNECT_MODAL.HEADER")}</h1>
                <div className="ta-left body-large brother-connect-subheader">{t("BROTHER_PLUS.BROTHER_CONNECT_MODAL.SUB_HEADER")}</div>
                <div className="brother-plus-benefits-wrapper ta-left body-medium">
                    <BPlusBenefitPoints cname="bplus-service-points-tick-icon" />
                </div>
                <div className="popup-terms-and-conditions body-medium-large ta-left">
                    <Trans i18nKey="BROTHER_PLUS.BROTHER_CONNECT_MODAL.TERMS_AND_CONDITIONS">
                        I accept  <a className="caveat-txt-link brother-connect-link" href={termsAndConditionLink} target="_blank" rel="noreferrer">terms and conditions </a>
                    </Trans>
                </div>
                <div className="brother-connect-privacy-policy body-small ta-left">
                    <Trans i18nKey="BROTHER_PLUS.BROTHER_CONNECT_MODAL.PRIVACY_POLICY">
                        Read our  <a className="caveat-txt-link" href={signup_privacyPolicy} target="_blank" rel="noreferrer">Privacy Policy</a> to find out how we collect and use your personal data.
                    </Trans>
                </div>
                <div className="continue-btn-wrapper">
                    <EcoProButton cname="default" onBtnClick={() => onPopUpSubmit()}>{t("ECOPRO_BTNS.CONTINUE")}</EcoProButton>
                </div>
                {
                    (showSkip)
                        ? <div className="dashboard-modal-skip-wrapper"><EasyPayPlanSkipNow handleSkipNow={handleSkipNow} /></div>
                        : null
                }
            </div>
        </Container>
    )
}

export default DashboardPopup;
